import React, { useState, useRef } from "react";
import Qrcode from "qrcode.react";
import { Back } from "@/Icons/img";
import { useLocation } from "react-router-dom";
import { api } from "@/services/api";
import ModalPopup from "@/components/ModalPopup";
import { Form } from "@unform/web";
import * as Yup from "yup";
import Input from "@/components/Input";

import "bootstrap/dist/css/bootstrap-grid.min.css";
import { Container } from "./styles";

export const QrCode = () => {
	let { state } = useLocation();
	const [form, setForm] = useState(false);
	const formRef = useRef(null);
	const [modalPopup, setModalPopup] = useState(false);
	const [modalContent, setModalContent] = useState({
		title: "",
		content: "",
	});
	const [updateForm, setUpdateForm] = useState(false);

	async function handleSubmit(data) {
		try {
			// esquema de validacao
			const schema = Yup.object().shape({
				email: Yup.string()
					.email("E-mail inválido")
					.required("Campo obrigatório"),
			});

			await schema.validate(data, {
				abortEarly: false,
			});

			handleSendCupom(data);
			formRef.current.setErrors({});
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errorMessages = {};

				err.inner.forEach((error) => {
					errorMessages[error.path] = error.message;
				});

				formRef.current.setErrors(errorMessages);
			}
		}
	}

	function handleSendCupom({ email }) {
		setUpdateForm(true);

		api.post("consumer/coupons/send", {
			email,
			coupon: state?.data?.code,
		})
			.then((res) => {
				if (res.data.status === 200) {
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content: res.data.message,
					});
				}
			})
			.catch((error) => {
				console.error({ endPoint: "consumer/coupons/send", error });
				setModalContent({
					title: "Programa Fidelidade GERIOOX",
					content: "Ocorreu um erro!",
				});
			})
			.finally(() => {
				setModalPopup(true);
				setUpdateForm(false);
			});
	}

	return (
		<React.Fragment>
			<ModalPopup
				visible={modalPopup}
				message={modalContent}
				onClick={() => setModalPopup(false)}
			/>
			<Container>
				<aside className='d-none d-lg-flex'>
					<img
						loading='lazy'
						className='img-responsive'
						src={require("@/assets/img/cachorro@2x.jpg").default}
						alt='cao e gato'
					/>
				</aside>

				<section>
					<button
						className='backHistory'
						onClick={() => window.history.back()}>
						<Back />
					</button>
					<div className='block-qrcode'>
						<header>
							<div className='animal'>
								<img
									loading='lazy'
									src={
										state?.data?.kind === 1
											? require("@/assets/img/icone-dog.png")
													.default
											: require("@/assets/img/icone-gato@2x.png")
													.default
									}
									alt='icone gato'
								/>
								<p>{state?.data?.pet}</p>
							</div>
							<div className='info-cupom'>
								<p className='cupom-header'>Número do cupom</p>
								<h2 className='cupom-number'>
									{state?.data?.code}
								</h2>
								<p className='cupom-footer'>
									Cupom gerado no dia{" "}
									<strong>
										{state?.data?.created_in
											.split("-")
											.reverse()
											.join("/")}
									</strong>{" "}
									Validade do cupom{" "}
									<strong>
										{state?.data?.valid_until
											.split("-")
											.reverse()
											.join("/")}
									</strong>
								</p>
							</div>
						</header>
						<div className='qrcode'>
							<Qrcode
								value={state?.data?.code}
								size={168}
								renderAs='svg'
							/>
						</div>

						<div className='block-message'>
							<p className='block-message__text'>
								Leia o QR-Code acima ou{" "}
								<span onClick={() => setForm(!form)}>
									clique aqui
								</span>{" "}
								para enviar por e-mail.
							</p>
						</div>

						<Form
							style={{ display: form ? "flex" : "none" }}
							className='form'
							ref={formRef}
							onSubmit={handleSubmit}>
							<Input
								label={false}
								name='email'
								type='text'
								placeholder='Insira o email da loja'
							/>
							<button
								disabled={updateForm ? "disabled" : ""}
								className='btn-primary'
								type='submit'>
								{updateForm ? "Enviando" : "Enviar por e-mail"}
							</button>
						</Form>
					</div>
				</section>
			</Container>
		</React.Fragment>
	);
};

export default QrCode;
